import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import CropDialog from '../../tc-ui/image-crop/image-crop-dialog';
import RatingNode from './rating-node';
import Name from './name-node';
import { path, call, ifElse, always, equals } from 'ramda';

import { deleteCoverImageFromProfile } from '../../../stores/profile/company/profile-actions.js';
import { deleteCoverImageFromLocation } from '../../../stores/profile/location/location-actions.js';
import { deleteCoverImageFromProduct } from '../../../stores/profile/product/product-actions.js';

import Icon from '../../tc-ui/icon';

class CoverPhotoContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.setContainerWidth();
  }

  setContainerWidth = () => {
    this.setState({
      containerWidth: findDOMNode(this.refs.outerContainer) && findDOMNode(this.refs.outerContainer).offsetWidth,
    });
  };

  getCompanyTypesToDisplay = () => {
    const { profileToShow } = this.props;

    let companyTypes = profileToShow.companyTypes || [];
    if (companyTypes[0] === '') companyTypes = companyTypes.slice(1);
    const itemsPerTypeArray = profileToShow.type === 'Contractor' ? 2 : 3;

    if (companyTypes.length) {
      return companyTypes.reduce((displayObject, type, index, types) => {
        const { rowItems, finalArray } = displayObject;
        let string = '';

        const buildSpan = span => (
          <span
            key={`span${index}`}
            style={{ display: 'inline-block', wordWrap: 'wrap-text', whiteSpace: 'pre-wrap', fontSize: '16px' }}
          >
            {span.toUpperCase()}
          </span>
        );

        if (
          (((index + 1) % itemsPerTypeArray === 0) && index !== 0) ||
          ((types.length < itemsPerTypeArray) && (index === types.length - 1)) ||
          index === types.length - 1
        ) {
          string += type;
          rowItems.push(buildSpan(string));
          finalArray.push(
            <div key={`column${index}`}style={{
              marginTop: finalArray.length === 0 ? '8px' : '0px',
              display: index === types.length - 1 ? 'inline-block' : 'block',
            }}
            >
              {rowItems}
            </div>
          );

          displayObject.rowItems = [];
        } else {
          string += `${type}, `;
          rowItems.push(buildSpan(string));
        }
        if (index < types.length - 1) return displayObject;
        return finalArray;
      }, {
        rowItems: [],
        finalArray: [],
      });
    }
  };

  _removeSpinnerOnLoad = () => {
    const { profileToShow } = this.props;
    const image = new Image();
    image.src = profileToShow.coverImageUrl;
    image.onload = this._toggleLoader.bind(this, 'coverPhoto', false);
  };

  coverImageSourceChanged = coverImageUrl => {
    const { _saveField, routeName } = this.props;
    _saveField({
      route: routeName,
      updateField: 'coverImageUrl',
      updateBody: coverImageUrl,
    });
    this._removeSpinnerOnLoad();
  };

  _toggleLoader = (field, isLoading) => {
    this.setState({
      [`${field}IsLoading`]: isLoading,
    });
  };

  deleteCoverImage = () => {
    const { routeName, dispatch, params } = this.props;
    if (routeName === 'profile') dispatch(deleteCoverImageFromProfile('profileCover'));
    if (routeName === 'location') dispatch(deleteCoverImageFromLocation('locationCover', params.locationId));
    if (routeName === 'product') dispatch(deleteCoverImageFromProduct('productCover', params.productId));
  };

  numOfCompanyTypes = path(['companyTypes', 'length'], this.props.profileToShow) || 0;

  heightForBackground = () => call(ifElse(
    equals(true),
      always(400),
    always(350),
  ), this.numOfCompanyTypes > 5);

  coverImageEditIcon = () => {
    const { profileToShow, routeName } = this.props;

    const coverPhotoTypes = {
      profile: [{
        maxSize: 1500,
        name: 'profileCover',
        onStart: this._toggleLoader.bind(this, 'coverPhoto', true),
        onChange: this.coverImageSourceChanged,
      }],
      location: [{
        maxSize: 1500,
        name: `locationCover${profileToShow.locationId}`,
        onStart: this._toggleLoader.bind(this, 'coverPhoto', true),
        onChange: this.coverImageSourceChanged,
      }],
      product: [{
        maxSize: 1500,
        name: `productCover${profileToShow.productId}`,
        onStart: this._toggleLoader.bind(this, 'coverPhoto', true),
        onChange: this.coverImageSourceChanged,
      }],
    };
    const coverPhotoNames = {
      profile: 'profileCover',
      location: `locationCover${profileToShow.locationId}`,
      product: `productCover${profileToShow.productId}`,
    };
    if (profileToShow.coverImageUrl) {
      return (
        <div>
          <div className="profile-cover-edit-image-icon" style={{ right: '44px' }}>
            <CropDialog
              confirmCroppedFn={this.coverImageSourceChanged}
              uploadStartFn={this._toggleLoader.bind(this, 'coverPhoto', true)}
              cropWidth={1200}
              cropHeight={this.heightForBackground()}
              imageName={coverPhotoNames[routeName]}
              dialogWidth="1200px"
            >
              <div>
                <Icon
                  className="tc-icon-mode_edit"
                  style={{ fontSize: '16px', verticalAlign: 'middle' }}
                />
                <span style={{ marginLeft: '8px' }}>Change Cover Photo</span>
              </div>
            </CropDialog>
          </div>
          <div onClick={this.deleteCoverImage} className="profile-cover-edit-image-icon" style={{ right: '4px' }}>
            <Icon
              className="tc-icon-delete2"
              style={{ fontSize: '16px', verticalAlign: 'middle' }}
            />
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="add-cover-image-url">
          <CropDialog
            confirmCroppedFn={this.coverImageSourceChanged}
            uploadStartFn={this._toggleLoader.bind(this, 'coverPhoto', true)}
            cropWidth={1200}
            cropHeight={this.heightForBackground()}
            imageName={coverPhotoNames[routeName]}
            dialogWidth="800px"
          >
            <Icon
              style={{
                fontSize: '48px',
                textAlign: 'center',
                verticalAlign: 'middle',
                marginRight: '16px',
                border: '2px dashed',
                zIndex: '0',
              }}
              className="tc-icon-add description-segments-add-icon"
            />
              <span
                style={{
                  display: 'inline-block',
                  verticalAlign: 'middle',
                }}
                className="description-segments-add-label"
              >
                Add Cover Photo
              </span>
          </CropDialog>
        </div>
      </div>
    );
  };

  render() {
    const { routeName, profileToShow, isEditable, isViewingOwnProfile, isSingleLocSupplier } = this.props;
    const coverPhotoGradient = profileToShow.coverImageUrl ? <div className="cover-photo-gradient" /> : undefined;
    const companyTypesToDisplay = this.getCompanyTypesToDisplay();
    const rating = profileToShow.rating;

    const coverContainerStyle = {
      position: 'relative',
      minHeight: `${this.heightForBackground()}px`,
      maxHeight: `${this.heightForBackground()}px`,
      top: isViewingOwnProfile ? '' : '64px',
      overflow: 'hidden',
    };

    const coverBackgroundStyle = {
      backgroundImage: `url(${profileToShow.coverImageUrl})`,
      position: 'relative',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundColor: '#e5e5e5',
      backgroundSize: 'cover',
      height: `${this.heightForBackground()}px`,
      opacity: '0.9',
    };

    const styleForTopBar = {
      get top() {
        let defaultPosition = this.numOfCompanyTypes > 5 ? -85 : -70;
        if (companyTypesToDisplay && routeName !== 'product') {
          defaultPosition -= (22 * (companyTypesToDisplay.length || 1));
        } else if (routeName !== 'product' && isEditable) {
          defaultPosition -= 22;
        }
        if (
          routeName === 'location' &&
          profileToShow.productType === 'accommodation' &&
          (rating && rating.type || isEditable) || (routeName === 'profile' && isSingleLocSupplier)
        ) {
          defaultPosition -= 22;
        }
        return `${defaultPosition}px`;
      },
      get color() {
        if (!profileToShow.coverImageUrl) return 'rbga(0, 0, 0, 0.81)';
      },
    };

    return (
      <div style={coverContainerStyle} className={`profile-cover-photo ${this.state.coverPhotoIsLoading ? ' image-loading-indicater' : ''}`}>
        <div style={coverBackgroundStyle} />
        {coverPhotoGradient}
        <div className="profile-top-bar-top-info" ref="outerContainer" style={styleForTopBar}>
          <Name {...this.props} containerWidth={this.state.containerWidth} />
          {/*<CompanyTypes companyTypesToDisplay={companyTypesToDisplay} {...this.props} />*/}
          {
            routeName !== 'product' ?
            <RatingNode
              isSingleLocSupplier={isSingleLocSupplier}
              {...this.props}
            /> : <span/>
          }
        </div>
        {isEditable ? this.coverImageEditIcon() : undefined}
      </div>
    );
  }
}

CoverPhotoContainer.propTypes = {
  profileToShow: PropTypes.object,
  _saveField: PropTypes.func,
  routeName: PropTypes.string,
  dispatch: PropTypes.func,
  isEditable: PropTypes.bool,
  params: PropTypes.object,
  isViewingOwnProfile: PropTypes.bool,
  isSingleLocSupplier: PropTypes.bool,
};

export default CoverPhotoContainer;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/cover-photo-container.jsx